// 封装了search和page方法
export default (withScroll = true) => {
  return {
    data() {
      return {
        searchParams: null,
        page: {
          pageLimit: 10,
          current: 1,
          pageSizes: [10, 20, 50, 100], // 每页显示条数
          layout: 'total, sizes, prev, pager, next, jumper', // 布局
          total: 0, // 总数
        },
      };
    },
    computed: {
      //
      pageParams4Api() {
        return {
          current: this.page.current,
          size: this.page.pageLimit,
        };
      },
    },
    methods: {
      // 删除后 如果没数据 需要跳分页
      afterDeleteJumpPage() {
        if (_.get(this, 'list.length') === 1) {
          this.page.current = this.page.current > 1 ? this.page.current - 1 : 1;
        }
      },
      handleSizeChange(val) {
        this.page.pageLimit = val;
        this.page.current = 1;
        this.initData && this.initData();
        this._scroll();
      },
      handleCurrentChange(val) {
        this.page.current = val;
        this.initData && this.initData();
        this._scroll();
      },
      _scroll() {
        return withScroll && utils.scrollTo(0, 600);
      },
      // 搜索
      handleSeach(val, resetPages = true) {
        if (val) {
          let { id } = val;
          if (id) {
            id = Number(id);
            val.id = id;
          }
        }
        resetPages && (this.page.current = 1);
        this.searchParams = val;
        this.initData();
        console.log(val, 'val');
      },
    },
  };
};
